import { FormControl, InputLabel } from "@mui/material";
import { useEffect, useState } from "react";
import { Controller, useFormContext } from "react-hook-form"
import { ClassificacaoGeracao } from "../../../../components/Combobox/ClassificacaoGeracao";
import { Fases } from "../../../../components/Combobox/Fases";
import { ModalidadeGD } from "../../../../components/Combobox/ModalidadeGD";
import { TipoInstalacao } from "../../../../components/Combobox/TipoInstalacao";
import { TipoRamal } from "../../../../components/Combobox/TipoRamal";
import { TransformadorParticular } from "../../../../components/Combobox/TransformadorParticular";
import { HelperText } from "../../../../components/Errors/HelperText";
import { WhiteInput } from "../../../../components/Inputs/InputText";
import servSolicitacaoAcesso from '../../../../services/login/servSolicitacaoAcesso' 

import styles from "../Cadastro.module.css";
const Geracao = ({ setIsLoading, setOpenError, setErrorMessage, parecerProjeto, parecerViabilidade, situacaoSolic, onKeyDown, isModalidadeGD, setIsModalidadeGD, goParticipantes, setParticipantes }) => {
    const { control, getValues, setValue, watch, formState: { errors, dirtyFields }} = useFormContext();
    const [isSolicitacaoMinigeracao, setIsSolicitacaoMinigeracao] = useState(false);
    const watchClassifGeracao = watch("ClassificacaoGeracao");
    const watchModalidadeGD = watch("ModalidadeGD");

    const editavel = (
        situacaoSolic === 1 || situacaoSolic === 4 || situacaoSolic === 5 || (parecerProjeto === 2 && parecerViabilidade === 2) 
        ? false 
        : true
    );

    useEffect(() => {
        verificaModalidadeGD();
    }, [watchModalidadeGD]);
    
    const verificaModalidadeGD = async () => {
        var modalidadeGDValue = getValues("ModalidadeGD")?.value;

        if(goParticipantes.length > 0 && dirtyFields?.ModalidadeGD) {
            try {
                for (const participante of goParticipantes) {
                    await RemoverParticipante(participante.Id);
                }
                setParticipantes([]);
            } catch (err) {
                console.log(err);
            }
        }

        setIsModalidadeGD(modalidadeGDValue === 4);
    }

    useEffect(() => {
        verificaClassificacaoGeracao();
    }, [getValues("ClassificacaoGeracao"), watchClassifGeracao]);

    const verificaClassificacaoGeracao = () => {
        var classificacaoGeracao = getValues("ClassificacaoGeracao")?.value;
        
        // Verifica se classificação de geração é minigeração (2), para disponibilizar somente os campos desse tipo
        if(classificacaoGeracao === 2) {
            setIsSolicitacaoMinigeracao(true);
        } else {
            defineCamposMinigeracaoDefault();
            setIsSolicitacaoMinigeracao(false);
        }
    }

    const defineCamposMinigeracaoDefault = () => {
        setValue("TipoLigacaoTransformador", " ");
        setValue("PercImpedanciaTransf", 0);
        setValue("TransformadorParticular", {
            label: 'Não se aplica',
            value: 1
        });
        setValue("TipoInstalacao", {
            label: 'Não se aplica',
            value: 1
        });
    }

    const formatInputValue = (value) => {
        value = value.replace(/[^0-9.,]/g, '');
    
        const [integerPart, decimalPart] = value.split(/[.,]/);
        if (decimalPart && decimalPart.length > 2) {
            value = `${integerPart}.${decimalPart.slice(0, 2)}`;
        }
    
        return value.replace(',', '.');
    };

    const RemoverParticipante = async (participanteId) => {
        try {
            await servSolicitacaoAcesso.RemoverParticipanteDaSolicitacao(participanteId);
        } catch (err) {
            throw err;
        }
    }

    return (
        <div>     
            <div className={styles['input-container']}>
                <Controller
                    name="ClassificacaoGeracao"
                    control={control}
                    render={({field}) => (
                        <FormControl variant="outlined" className={styles['campos-m']} style={{ zIndex: 3}}>
                            <InputLabel htmlFor="solicitacao-glassificacao-geracao" shrink sx={{ color: "#B8B8B8" }} >Classificação geração particular</InputLabel>
                            <ClassificacaoGeracao
                                field={field} 
                                disabled={!editavel} 
                                id={"solicitacao-glassificacao-geracao"} 
                                name="Classificação geração" 
                                placeholder={"Classificação geração"} 
                                onKeyDown={onKeyDown} 
                                className={`${errors?.ClassificacaoGeracao ? styles.campoComValorErrado : ""}`}
                            />
                            { errors?.ClassificacaoGeracao && (
                                <HelperText text={errors?.ClassificacaoGeracao?.message} />
                            )}
                        </FormControl>
                    )}
                />

                <Controller
                    name="ModalidadeGD"
                    control={control}
                    render={({field}) => (
                        <FormControl variant="outlined" className={styles['campos-m']}  style={{ zIndex: 3}}>
                            <InputLabel htmlFor="solicitacao-modalidade-gd" shrink sx={{ color: "#B8B8B8" }} >Modalidade GD</InputLabel>
                            <ModalidadeGD
                                field={field} disabled={!editavel} id={"solicitacao-modalidade-gd"} name="Modalidade GD" placeholder={"Modalidade GD"} onKeyDown={onKeyDown} className={`${errors?.ModalidadeGD ? styles.campoComValorErrado : ""}`}
                            />
                            { errors?.ModalidadeGD && (
                                <HelperText text={errors?.ModalidadeGD?.message} />
                            )}
                        </FormControl>
                    )}
                />
            </div>

            <div className={styles['input-container']}>
                <Controller
                    name="TipoRamal"
                    control={control}
                    render={({field}) => (
                        <FormControl variant="outlined" className={styles['campos-m']} style={{ zIndex: 2}}>
                            <InputLabel htmlFor="solicitacao-TipoRamal" shrink sx={{ color: "#B8B8B8" }} >Tipo ramal</InputLabel>
                            <TipoRamal 
                                field={field} 
                                disabled={!editavel} 
                                name="TipoRamal" 
                                id="solicitacao-TipoRamal" 
                                placeholder="Tipo ramal" 
                                onKeyDown={onKeyDown}
                                className={`${errors?.TipoRamal ? styles.campoComValorErrado : ""}`}
                            />
                            { errors?.TipoRamal && (
                                <HelperText text={errors?.TipoRamal?.message} />
                            )}
                        </FormControl>
                    )}
                />

                <Controller
                    name="TipoConexao"
                    control={control}
                    render={({field}) => (
                        <FormControl variant="outlined" className={styles['campos-m']} style={{ zIndex: 2}}>
                            <InputLabel htmlFor="solicitacao-conexao" shrink sx={{ color: "#B8B8B8" }} >Tipo de conexão</InputLabel>
                            <Fases 
                                field={field} 
                                disabled={!editavel} 
                                id={"solicitacao-conexao"} 
                                name="Tipo de conexão" 
                                placeholder={"Tipo de conexão"}
                                onKeyDown={onKeyDown}
                                className={`${errors?.TipoConexao ? styles.campoComValorErrado : ""}`}
                            />
                            { errors?.TipoConexao && (
                                <HelperText text={errors?.TipoConexao?.message} />
                            )}
                        </FormControl>
                    )}
                />
            </div>

            <div className={styles['input-container']}>
                <Controller
                    name="BitolaRamal"
                    control={control}
                    render={({field}) => (
                        <FormControl variant="outlined" className={styles['campos-m']}>
                            <InputLabel htmlFor="solicitacao-Bitola" shrink sx={{ color: "#B8B8B8" }} >Bitola (mm²)</InputLabel>
                            <WhiteInput
                                fullWidth 
                                placeholder="Bitola" 
                                id="solicitacao-Bitola" 
                                name="Bitola" 
                                {...field} 
                                readOnly={!editavel}
                                onKeyDown={onKeyDown}
                                className={`${errors?.BitolaRamal ? styles.campoComValorErrado : ""}`}
                            />
                            { errors?.BitolaRamal && (
                                <HelperText text={errors?.BitolaRamal?.message} />
                            )}
                        </FormControl>
                    )}
                />

                { !isSolicitacaoMinigeracao && ( 
                    <FormControl variant="outlined" className={styles['campos-m']}></FormControl>
                )}
                
                { isSolicitacaoMinigeracao && (
                    <Controller
                        name="PercImpedanciaTransf"
                        control={control}
                        render={({field}) => (
                            <FormControl variant="outlined" className={styles['campos-m']}>
                                <InputLabel htmlFor="solicitacao-PercImpedanciaTransf" shrink sx={{ color: "#B8B8B8" }} >Impedância Transf. (%)</InputLabel>
                                <WhiteInput
                                    fullWidth 
                                    placeholder="Impedância Transf. (%)" 
                                    id="solicitacao-PercImpedanciaTransf" 
                                    name="PercImpedanciaTransf" 
                                    {...field} 
                                    readOnly={!editavel} 
                                    type="number"
                                    onKeyDown={onKeyDown}
                                    className={`${errors?.PercImpedanciaTransf ? styles.campoComValorErrado : ""}`}
                                />
                                { errors?.PercImpedanciaTransf && (
                                    <HelperText text={errors?.PercImpedanciaTransf?.message} />
                                )}
                            </FormControl>
                        )}
                    />
                )}
            </div>

            { isSolicitacaoMinigeracao && (
                <div className={styles['input-container']}>
                    <Controller
                        name="TransformadorParticular"
                        control={control}
                        render={({field}) => (
                            <FormControl variant="outlined" className={styles['campos-m']} style={{ zIndex: 3}}>
                                <InputLabel htmlFor="solicitacao-transformador" shrink sx={{ color: "#B8B8B8" }} >Transformador particular</InputLabel>
                                <TransformadorParticular
                                    field={field} 
                                    disabled={!editavel} 
                                    id={"solicitacao-transformador"} 
                                    name="Transformador particular" 
                                    placeholder={"Transformador particular"}
                                    onKeyDown={onKeyDown}
                                    className={`${errors?.TransformadorParticular ? styles.campoComValorErrado : ""}`}
                                />
                                { errors?.TransformadorParticular && (
                                    <HelperText text={errors?.TransformadorParticular?.message} />
                                )}
                            </FormControl>
                        )}
                    />

                    <Controller
                        name="TipoInstalacao"
                        control={control}
                        render={({field}) => (
                            <FormControl variant="outlined" className={styles['campos-m']} style={{ zIndex: 3}}>
                                <InputLabel htmlFor="solicitacao-TipoInstalacao" shrink sx={{ color: "#B8B8B8" }} >Tipo de instalação</InputLabel>
                                <TipoInstalacao
                                    field={field} 
                                    disabled={!editavel} 
                                    id={"solicitacao-TipoInstalacao"} 
                                    name="Tipo de instalação" 
                                    placeholder={"Tipo de instalação"}
                                    onKeyDown={onKeyDown}
                                    className={`${errors?.TipoInstalacao ? styles.campoComValorErrado : ""}`}
                                />
                                { errors?.TipoInstalacao && (
                                    <HelperText text={errors?.TipoInstalacao?.message} />
                                )}
                            </FormControl>
                        )}
                    />
                </div>
            )}

            <div className={styles['input-container']}>
                <Controller 
                    name="Armazenamento"
                    control={control}
                    render={({field}) => (
                        <FormControl variant="outlined" style={{ width: "82%" }}>
                            <InputLabel htmlFor="solicitacao-Armazenamento" shrink sx={{ color: "#B8B8B8" }} >Armazenamento (se houver)</InputLabel>
                            <WhiteInput
                                fullWidth 
                                placeholder="Armazenamento" 
                                id="solicitacao-armazenamento" 
                                name="Armazenamento" 
                                {...field} 
                                readOnly={!editavel} 
                                onKeyDown={onKeyDown}
                                className={`${errors?.Armazenamento ? styles.campoComValorErrado : ""}`}
                            />
                            { errors?.Armazenamento && (
                                <HelperText text={errors?.Armazenamento?.message} />
                            )}
                        </FormControl>
                    )}
                />
            </div>

            { isSolicitacaoMinigeracao && (
                <div className={styles['input-container']}>
                    <Controller
                        name="TipoLigacaoTransformador"
                        control={control}
                        render={({field}) => (
                            <FormControl variant="outlined" className={styles['campos-g']}>
                                <InputLabel htmlFor="solicitacao-TipoLigacaoTransformador" shrink sx={{ color: "#B8B8B8" }} >Tipo de ligação do transformador</InputLabel>
                                <WhiteInput
                                    fullWidth 
                                    placeholder="Tipo de ligação do transformador" 
                                    id="solicitacao-TipoLigacaoTransformador" 
                                    name="TipoLigacaoTransformador" 
                                    {...field} 
                                    readOnly={!editavel} 
                                    onKeyDown={onKeyDown}
                                    className={`${errors?.TipoLigacaoTransformador ? styles.campoComValorErrado : ""}`}
                                />
                                { errors?.TipoLigacaoTransformador && (
                                    <HelperText text={errors?.TipoLigacaoTransformador?.message} />
                                )}
                            </FormControl>
                        )}
                    />
                </div>
            )}

            <div className={styles['input-container']} style={{ marginBottom: "20px" }}>
               <Controller
                    name="DisjustorUc"
                    control={control}
                    render={({field}) => (
                        <FormControl variant="outlined" className={styles['campos-m']}>
                            <InputLabel htmlFor="solicitacao-DisjustorUc" shrink sx={{ color: "#B8B8B8" }} >Disjuntor UC</InputLabel>
                            <WhiteInput
                                fullWidth 
                                placeholder="Disjuntor UC" 
                                id="solicitacao-DisjustorUc" 
                                name="DisjustorUc" 
                                {...field} 
                                readOnly={!editavel} 
                                type="number"
                                onKeyDown={onKeyDown}
                                className={`${errors?.DisjustorUc ? styles.campoComValorErrado : ""}`}
                            />
                            { errors?.DisjustorUc && (
                                <HelperText text={errors?.DisjustorUc?.message} />
                            )}
                        </FormControl>
                    )}
                />

                <Controller
                    name="AreaArranjos"
                    control={control}
                    render={({ field }) => (
                        <FormControl variant="outlined" className={styles['campos-m']}>
                            <InputLabel htmlFor="solicitacao-AreaArranjos" shrink sx={{ color: "#B8B8B8" }}>
                                Área de arranjos (m²)
                            </InputLabel>
                            <WhiteInput
                                fullWidth
                                placeholder="Área de arranjos"
                                id="solicitacao-AreaArranjos"
                                name="AreaArranjos"
                                {...field}
                                readOnly={!editavel}
                                type="text"
                                onKeyDown={onKeyDown}
                                onChange={(e) => {
                                    e.target.value = formatInputValue(e.target.value);
                                    field.onChange(e);
                                }}
                                className={`${errors?.AreaArranjos ? styles.campoComValorErrado : ""}`}
                            />
                            {errors?.AreaArranjos && (
                                <HelperText text={errors?.AreaArranjos?.message} />
                            )}
                        </FormControl>
                    )}
                />
            </div>
        </div>
    )
}

export { Geracao }